import React from 'react';

const ManuscriptHandlingFee = () => {
  return (
    <div className="container py-4">
      <div className="row mb-5">
        <div className="col-lg-8 mx-auto">
          <h1 className="mb-4 text-center">Manuscript Handling Fee</h1>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Fee Structure</h2>
              <p className="card-text">
                FUWJALS charges a manuscript handling fee to cover the costs of peer review, 
                editorial processing, and administrative services. This fee ensures the 
                sustainability of our high-quality editorial processes.
              </p>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Current Fees</h2>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-primary">
                    <tr>
                      <th>Manuscript Type</th>
                      <th>Standard Fee (USD)</th>
                      <th>Developing Countries</th>
                      <th>Students</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Original Research Article</td>
                      <td>$150</td>
                      <td>$100</td>
                      <td>$75</td>
                    </tr>
                    <tr>
                      <td>Review Article</td>
                      <td>$200</td>
                      <td>$150</td>
                      <td>$100</td>
                    </tr>
                    <tr>
                      <td>Short Communication</td>
                      <td>$100</td>
                      <td>$75</td>
                      <td>$50</td>
                    </tr>
                    <tr>
                      <td>Case Study</td>
                      <td>$125</td>
                      <td>$85</td>
                      <td>$65</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">What the Fee Covers</h2>
              <div className="row">
                <div className="col-md-6">
                  <h4>Editorial Services</h4>
                  <ul>
                    <li>Initial manuscript screening</li>
                    <li>Editor-in-Chief review</li>
                    <li>Managing Editor coordination</li>
                    <li>Editorial decision making</li>
                    <li>Quality assurance checks</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h4>Review Process</h4>
                  <ul>
                    <li>Peer reviewer identification</li>
                    <li>Review coordination</li>
                    <li>Multiple review rounds</li>
                    <li>Reviewer compensation</li>
                    <li>Review quality monitoring</li>
                  </ul>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <h4>Technical Services</h4>
                  <ul>
                    <li>Manuscript system maintenance</li>
                    <li>File processing and storage</li>
                    <li>Plagiarism detection</li>
                    <li>Format conversion</li>
                    <li>Digital archiving</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h4>Administrative Costs</h4>
                  <ul>
                    <li>Staff salaries and training</li>
                    <li>Office operations</li>
                    <li>Communication systems</li>
                    <li>Legal and compliance</li>
                    <li>Professional development</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Payment Timeline</h2>
              <div className="alert alert-info">
                <h4>Important Note</h4>
                <p className="mb-0">
                  The manuscript handling fee is charged <strong>upon submission</strong> and is 
                  <strong>non-refundable</strong>, regardless of the final editorial decision.
                </p>
              </div>
              
              <h4>Payment Process</h4>
              <ol>
                <li>Submit your manuscript through our online system</li>
                <li>Receive fee invoice within 24 hours</li>
                <li>Make payment using available methods</li>
                <li>Submit payment confirmation</li>
                <li>Editorial review process begins</li>
              </ol>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Fee Waivers and Discounts</h2>
              <h4>Developing Country Discount</h4>
              <p className="card-text">
                Authors from countries classified by the World Bank as low-income or 
                lower-middle-income economies are eligible for reduced fees.
              </p>
              
              <h4>Student Discount</h4>
              <p className="card-text">
                Full-time students can apply for a 50% discount. Proof of current 
                enrollment is required.
              </p>
              
              <h4>Complete Fee Waiver</h4>
              <p className="card-text">
                In exceptional circumstances, complete fee waivers may be granted for:
              </p>
              <ul>
                <li>Authors from least developed countries (LDCs)</li>
                <li>Researchers facing financial hardship</li>
                <li>High-quality invited manuscripts</li>
                <li>Special issue contributions</li>
              </ul>
              
              <h4>Application Process</h4>
              <p className="card-text">
                To apply for a waiver or discount, email: <a href="mailto:fee-waiver@fuwukari.edu.ng">fee-waiver@fuwukari.edu.ng</a>
              </p>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Payment Methods</h2>
              <div className="row">
                <div className="col-md-6">
                  <h4>International Payments</h4>
                  <ul>
                    <li>Bank wire transfer</li>
                    <li>PayPal</li>
                    <li>Credit/Debit cards</li>
                    <li>Western Union</li>
                    <li>MoneyGram</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h4>Nigerian Payments</h4>
                  <ul>
                    <li>Bank transfer (Naira)</li>
                    <li>Online banking</li>
                    <li>Mobile money transfer</li>
                    <li>Bank draft</li>
                    <li>Cash deposit</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Fee Transparency</h2>
              <h4>Cost Breakdown</h4>
              <div className="row">
                <div className="col-md-6">
                  <canvas id="feeChart" width="300" height="200"></canvas>
                </div>
                <div className="col-md-6">
                  <ul className="list-unstyled">
                    <li><i className="fas fa-circle text-primary me-2"></i>Editorial Services (40%)</li>
                    <li><i className="fas fa-circle text-success me-2"></i>Peer Review (30%)</li>
                    <li><i className="fas fa-circle text-warning me-2"></i>Technical Infrastructure (20%)</li>
                    <li><i className="fas fa-circle text-info me-2"></i>Administrative Costs (10%)</li>
                  </ul>
                </div>
              </div>
              
              <h4>Annual Fee Review</h4>
              <p className="card-text">
                Our fees are reviewed annually and adjusted based on:
              </p>
              <ul>
                <li>Operating cost changes</li>
                <li>Industry standards</li>
                <li>Service improvements</li>
                <li>Economic factors</li>
              </ul>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Frequently Asked Questions</h2>
              
              <h5>Q: Is the fee refundable if my paper is rejected?</h5>
              <p>A: No, the manuscript handling fee is non-refundable as it covers the cost of the editorial review process regardless of the outcome.</p>
              
              <h5>Q: When do I need to pay the fee?</h5>
              <p>A: Payment is required upon manuscript submission, before the editorial review begins.</p>
              
              <h5>Q: Can I pay in local currency?</h5>
              <p>A: Yes, we accept payments in Nigerian Naira and other major currencies. Exchange rates are updated daily.</p>
              
              <h5>Q: How do I apply for a fee waiver?</h5>
              <p>A: Submit a waiver application with supporting documentation to fee-waiver@fuwukari.edu.ng before manuscript submission.</p>
              
              <h5>Q: Are there any additional charges?</h5>
              <p>A: No, the manuscript handling fee covers all editorial services. Publication is free upon acceptance.</p>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Contact Information</h2>
              <p className="card-text">
                For questions about fees, payments, or waivers:
              </p>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Financial Office</strong><br />
                    Email: finance@fuwukari.edu.ng<br />
                    Phone: +234 XXX XXX XXXX
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Editorial Office</strong><br />
                    Email: editorial@fuwukari.edu.ng<br />
                    Phone: +234 XXX XXX XXXX
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManuscriptHandlingFee;